import { Amplify } from 'aws-amplify';
import PageLayout from './src/layouts/Page';
import InstallerLayout from './src/layouts/Installer';
import InvoicePaymentLayout from './src/layouts/InvoicePayment';
import './src/styles/fonts.css';
import awsExports, { detectPortal } from './src/aws-exports';

let currentPortal = null;

const configureAmplify = pathname => {
  const nextPortal = detectPortal(pathname);
  if (nextPortal === currentPortal) {
    return;
  }
  Amplify.configure(awsExports(pathname));
  currentPortal = nextPortal;
};

if (typeof window !== 'undefined') {
  configureAmplify(window.location?.pathname);
}

const shouldUpdateScroll = context => {
  if (
    context &&
    context.routerProps &&
    context.routerProps.location &&
    context.routerProps.location.hash
  ) {
    // preserve scroll position for anchor links
    return true;
  }
  window.scrollTo(0, 0);
  return false;
};

export const wrapPageElement = pageData => {
  if (pageData.props.location.pathname.startsWith('/installer/')) {
    return <InstallerLayout {...pageData} />;
  }
  if (pageData.props.location.pathname.startsWith('/invoice-payment/')) {
    return <InvoicePaymentLayout {...pageData} />;
  }
  return <PageLayout {...pageData} />;
};

export const onRouteUpdate = ({ location }) => {
  configureAmplify(location?.pathname);
};

export { default as wrapRootElement } from './src/layouts/Root';
export { shouldUpdateScroll };
